/** Shared local image fallback for missing or broken assets. */
export const FALLBACK_IMAGE = "/assets/img.png";

/**
 * Normalizes relative public asset paths (e.g. ../assets/x) to root-absolute URLs
 * so images resolve correctly on nested SPA routes.
 */
export function resolvePublicAssetPath(src, fallbackSrc = FALLBACK_IMAGE) {
  if (src == null || src === "") return fallbackSrc;
  const value = String(src).trim();
  if (!value) return fallbackSrc;
  if (
    value.startsWith("http://") ||
    value.startsWith("https://") ||
    value.startsWith("data:") ||
    value.startsWith("blob:")
  ) {
    return value;
  }
  if (value.startsWith("/")) return value;
  const withoutDots = value.replace(/^(?:\.\.\/|\.\/)+/, "");
  return `/${withoutDots}`;
}

/**
 * Switches an <img> to the shared fallback once. Prevents infinite error loops.
 * @param {React.SyntheticEvent<HTMLImageElement>} event
 * @param {string} [fallbackSrc]
 */
export function handleImageError(event, fallbackSrc = FALLBACK_IMAGE) {
  const img = event?.currentTarget || event?.target;
  if (!img || img.dataset.fallbackApplied === "true") return;
  img.dataset.fallbackApplied = "true";
  img.src = fallbackSrc;
}
